import { Requests } from '@erecruit/types';
import { getResourceApi } from '@erecruit/modules';
import { put, takeLatest } from 'redux-saga/effects';

import { fetchMessagesSuccess, fetchMessagesFail } from './reducer';
import { BroadcastMessagesResponseType } from './types';

function* fetchBroadcastMessages() {
  try {
    const requests = [new Requests.BroadcastMessageRequest({ filter: {} })];
    const response: BroadcastMessagesResponseType = yield getResourceApi().getResources(
      requests,
    );

    yield put(fetchMessagesSuccess(response[0].data));
  } catch (e) {
    yield put(fetchMessagesFail(e.message));
  }
}

function* watchForFetchBroadcastMessages() {
  yield takeLatest('broadcastMessages/fetchMessages', fetchBroadcastMessages);
}

export default [watchForFetchBroadcastMessages()];
